<template>

<div class="list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList()">
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">

		<div v-if="clientFFLNumbers.length > 0">
			<div class="title">FFL Number...</div>
			<select v-model="filters.client_ffl_number_id" @change="clearFilters()">
				<option v-for="(clientFFLNumber, index) in clientFFLNumbers" :key="index" :value="clientFFLNumber.client_ffl_number_id">{{ clientFFLNumber.ffl_number }}</option>
			</select>
			<div class="divider"></div>
		</div>

		<div class="title">Date of Report</div>
		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>
		<div class="divider"></div>
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.include_canceled ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('include_canceled')"></span>
				<label>Include Canceled Forms</label>
			</li>
		</ul>
		<div class="divider"></div>
		<div class="button neutral" @click="clearFilters()">Clear FIlters</div>
		<div class="divider"></div>
		<div class="button action" @click="startNewForm('3310.4')">New 3310.4 (Handguns)</div>
		<div class="button action" @click="startNewForm('3310.12')">New 3310.12 (Rifles)</div>
		<div class="divider"></div>
		<div class="extra-menu-item" @click="setBusinessDays()">Business Days</div>
		<div class="extra-menu-item" @click="setCLEOInfo()">CLEO Info</div>
		<div class="extra-menu-item" @click="setMultipleSalesSource()">Multiple Sales Source</div>
	</div>

	<div class="two-columns" style="grid-template-columns: 1fr 260px;">
		<div class="list">
			<table class="logbook-forms data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th>Transferee Name / Address</th>
						<th>Form / Date</th>
						<th class="center">Submitted</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr class="list clickable-list-item" v-for="(item, index) in logBookForms">
						<td @click="goToDetail(item)">
							<div v-if="item.inactive" style="float: left; height: 100%; background-color: red; color: white; margin: 0 0.5em 0 0; padding: 0 0.25em;">&nbsp;</div>
							{{ item.form_data.transferee_name }}<br>
							{{ item.form_data.transferee_address }}
						</td>
						<td @click="goToDetail(item)">
							{{ item.form_data.form_version }}<br>
							{{ $moment(item.date_created).format('MM/DD/YYYY') }}
						</td>
						<td class="center" @click="goToDetail(item)"><i v-if="!item.pdf_required" class="fa fa-check" /></td>
						<td class="links">
							<a class="link" :href="generatePDFLink(item.ffl_log_book_form_id)" target="_blank">Print</a>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if="logBookForms.length == 0" class="empty-list">No forms found</div>
		</div>
		<div class="list" style="border-left: 1px solid #ccc;">
			<table class="logbook-forms data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr><th>Multiple Firearms Sales</th></tr>
				</thead>
				<tbody>
					<tr>
						<td class="list">
							<div class="note">These are your current alerts</div>
							<span :class="['pointer', 'far', filters.include_dismissed_alerts ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('include_dismissed_alerts')"></span>
							<label> Include dismissed alerts</label>
						</td>
					</tr>
					<tr v-for="(multiPurchaseAlert, index) in multiPurchaseAlerts" :key="index">
						<td class="list">
							{{ multiPurchaseAlert.full_name }}<br>
							{{ multiPurchaseAlert.ffl_log_book_entry_ids.length }} {{ multiPurchaseAlert.form_version == '3310.4' ? 'handguns' : 'rifles' }}<br>
							{{ $moment(multiPurchaseAlert.start_date).format('MM/DD/YYYY') }} - {{ $moment(multiPurchaseAlert.end_date).format('MM/DD/YYYY') }}
							<div v-if="multiPurchaseAlert.closed" class="contols v-spaced">
								<div class="button neutral smaller spaced" @click="setMultiPurchaseAlertAction('reactivate', multiPurchaseAlert)">Reactivate Alert</div>
							</div>
							<div v-else class="contols v-spaced">
								<div class="button neutral smaller spaced" @click="setMultiPurchaseAlertAction('new', multiPurchaseAlert)">Start {{ multiPurchaseAlert.form_version }}</div>
								<div class="button neutral smaller spaced" @click="setMultiPurchaseAlertAction('dismiss', multiPurchaseAlert)">Dismiss Alert</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if="multiPurchaseAlerts.length == 0"  class="empty-list">No alerts found</div>
		</div>
	</div>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>New {{ formVersion }} ({{ formVersion == '3310.4' ? 'Handguns' : 'Rifles' }})</h2>
			<div class="content">
				<div class="note" style="padding: 0;">Search your log book dispositions to set the transferee...</div>
				<div class="input-with-control">
					<input type="text" v-model="search_contacts" placeholder="Search dispositions..." @keyup.enter="searchContacts()">
					<div class="button action input-go" @click="searchContacts()"><i class="fas fa-search"></i></div>
				</div>
				<ul v-if="contacts && contacts.length != 0" class="search-list">
					<li class="clickable-list-item" v-for="(contact, index) in contacts" @click="assignContact(contact)">
						<span>{{ contact.full_name || $fullName(contact) }}</span>
						<span>{{ contact.address_1 }} {{ contact.city }}, {{ contact.state }} {{ contact.zip_code }}</span>
					</li>
				</ul>
				<ul v-else-if="contactSearchMessage" class="search-list no-results">
					<li>{{ contactSearchMessage }}</li>
				</ul>
			</div>
			<div class="controls">
                <div class="button neutral spaced" @click="showModal = false">Cancel</div>
				<div class="button neutral spaced" @click="startBlankForm()">Start a Blank Form</div>
			</div>
		</div>
	</div>

	<div v-if="showSetBusinessDays" class="modal medium-modal">
		<div class="inner" style="width: 60em;">
			<h2>Set Business Days</h2>
			<div class="content">
				<p>If you dispose multiple firearms to the same person within five of your business days, you are required submit a 3310.</p>
				<p>Record your regular days of operation, plus dates you will be closed this year.</p>
				<div class="one-three-columns">
					<div>
						<h3>Regular Days</h3>
						<checkbox v-model="businessDays.sunday" label="Sunday" class="v-spaced"/>
						<checkbox v-model="businessDays.monday" label="Monday" class="v-spaced"/>
						<checkbox v-model="businessDays.tuesday" label="Tuesday" class="v-spaced"/>
						<checkbox v-model="businessDays.wednesday" label="Wednesday" class="v-spaced"/>
						<checkbox v-model="businessDays.thursday" label="Thursday" class="v-spaced"/>
						<checkbox v-model="businessDays.friday" label="Friday" class="v-spaced"/>
						<checkbox v-model="businessDays.saturday" label="Saturday" class="v-spaced"/>
					</div>
					<div>
						<h3>{{ new Date().getFullYear() }} Holidays / Closed Days</h3>
						<div v-for="(holiday, index) in businessDays.holidays" class="four-columns" style="grid-template-columns: 1fr 1fr 1fr 2em;">
							<div>
								<label>Description</label>
								<input type="text" v-model="holiday.description">
							</div>
							<div>
								<label>Start</label>
								<input type="date" v-model="holiday.start">
							</div>
							<div>
								<label>End</label>
								<input type="date" v-model="holiday.end">
							</div>
							<div style="padding: 0.5em 0 0 0;">
								<div class="button neutral small" @click="removeHolidayLine(index)"><i class="fa fa-trash"></i></div>
							</div>
						</div>
						<div class="button neutral small" @click="addHolidayLine()"><i class="fa fa-plus" /></div>
					</div>
				</div>
				<div v-if="modalMessage" class="message-overlay">
					<p>{{ modalMessage }}</p>
					<ul v-if="holidayErrors.length > 0">
						<li v-for="(error, index) in holidayErrors" :key="index">
							{{ error }}
						</li>
					</ul>
					<p v-if="saving"><i class="fa fa-spinner fa-spin" /></p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
                <div class="button cancel spaced" @click="showSetBusinessDays = false; modalMessage = false">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="saveBusinessDays()">Save</div>
			</div>
		</div>
	</div>

	<div v-if="showSetCLEOInfo" class="modal medium-modal">
		<div class="inner" style="width: 60em;">
			<h2>Set CLEO Info</h2>
			<div class="content">
				<p>Identify the official designated by the State or local authorities where you, the FFL, will be forwarding Copy 2.</p>
				<h3>Name and Address of Agency</h3>
				<div class="two-columns">
					<div>
						<label>Name of Agency</label>
						<input type="text" v-model="cleoInfo.cleo_name">
					</div>
					<div>
						<label>Full Street Address, City, and State</label>
						<input type="text" v-model="cleoInfo.cleo_address">
					</div>
				</div>
				<div class="two-columns">
					<div>
						<h3>3310.4 Email Address</h3>
						<checkbox v-model="cleoInfo.use_default_handguns" label="multiplehandgunsalesforms@atf.gov" class="v-spaced"/>
						<input type="text" v-model="cleoInfo.email_handguns_1" :placeholder="(cleoInfo.use_default_handguns ? 'Additional' : 'Alternate') + ' email address'">
						<input type="text" v-model="cleoInfo.email_handguns_2" :placeholder="(cleoInfo.use_default_handguns ? 'Additional' : 'Alternate') + ' email address'">
						<input type="text" v-model="cleoInfo.email_handguns_3" :placeholder="(cleoInfo.use_default_handguns ? 'Additional' : 'Alternate') + ' email address'">
					</div>
					<div>
						<h3>3310.12 Email Address</h3>
						<checkbox v-model="cleoInfo.use_default_long_guns" label="multiplelonggunsalesforms@atf.gov" class="v-spaced"/>
						<input type="text" v-model="cleoInfo.email_long_guns_1" :placeholder="(cleoInfo.use_default_long_guns ? 'Additional' : 'Alternate') + ' email address'">
						<input type="text" v-model="cleoInfo.email_long_guns_2" :placeholder="(cleoInfo.use_default_long_guns ? 'Additional' : 'Alternate') + ' email address'">
						<input type="text" v-model="cleoInfo.email_long_guns_3" :placeholder="(cleoInfo.use_default_long_guns ? 'Additional' : 'Alternate') + ' email address'">
					</div>
				</div>
				<div v-if="modalMessage" class="message-overlay">
					<p>{{ modalMessage }}</p>
					<p v-if="saving"><i class="fa fa-spinner fa-spin" /></p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
                <div class="button cancel spaced" @click="showSetCLEOInfo = false">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="saveCLEOInfo()">Save</div>
			</div>
		</div>
	</div>

	<div v-if="showMultipleSalesSource" class="modal medium-modal">
		<div class="inner" style="width: 60em;">
			<h2>Set Multiple Firearms Sales Source</h2>
			<div class="content">
				<p>Alerts of multiple firearms sales are typically generated when a 4473 is signed as transferred.<br>This ensures that alerts are only related to transfers involving a NICS check.</p>
				<p>If you aren't using Flight Deck's built-in 4473s, you can have alerts generated by log book<br>disposals instead. You may end up with alerts for transfers that don'trequire a NICS check,<br>e.g. repairs. Such alerts can simply be dismissed.</p>
				<p><b>Note:</b> changing the source is not retroactive and will only affect new dispositions.</p>
				<p class="label">Multiple Firearms Sales Source...</p>
				<binary-toggle v-model="multipleSalesSource" labels="Completed 4473,Logbook Disposal" values=",logbooks" :key="'multiple_sales_source_' + multipleSalesSource" />
				<div v-if="modalMessage" class="message-overlay">
					<p>{{ modalMessage }}</p>
					<p v-if="saving"><i class="fa fa-spinner fa-spin" /></p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
                <div class="button cancel spaced" @click="showMultipleSalesSource = false">Cancel</div>
				<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="saveMultipleSalesSource()">Save</div>
			</div>
		</div>
	</div>

	<div v-if="multiPurchaseAlertAction" class="modal medium-modal">
		<div class="inner">
			<h2>Multiple Firearms Sales Alert</h2>
			<div class="content">
				<table class="data-list" style="margin: 0 0 1em 0;">
					<tr><td><label class="full">Dates</label></td><td>{{ $moment(multiPurchaseAlertDetail.start_date).format('MM/DD/YYYY') }} - {{ $moment(multiPurchaseAlertDetail.end_date).format('MM/DD/YYYY') }}</td></tr>
					<tr><td><label class="full">Disposed To</label></td><td>{{ multiPurchaseAlertDetail.full_name }}</td></tr>
					<tr><td><label class="full">Form Type</label></td><td>{{ multiPurchaseAlertDetail.form_version }} ({{ multiPurchaseAlertDetail.form_version == '3310.4' ? 'Handguns' : 'Rifles' }})</td></tr>
					<tr><td><label class="full">Items</label></td><td>{{ multiPurchaseAlertDetail.ffl_log_book_entry_ids.length }}</td></tr>
				</table>
				<p v-if="multiPurchaseAlertAction == 'reactivate'">A reactivated alert can be converted to a 3310.<br>Are you sure you want to reactivate this alert?</p>
				<p v-if="multiPurchaseAlertAction == 'dismiss'">Are you sure you want to dismiss this alert?</p>
				<p v-if="multiPurchaseAlertAction == 'new'">You are about to start a new {{ multiPurchaseAlertDetail.form_version }} with {{ multiPurchaseAlertDetail.ffl_log_book_entry_ids.length }} items<br>from this multiple firearms sales alert.</p>
				<div v-if="modalMessage" class="message-overlay">
					<p>{{ modalMessage }}</p>
					<p v-if="saving"><i class="fa fa-spinner fa-spin" /></p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
                <div class="button cancel spaced" @click="multiPurchaseAlertAction = ''">Cancel</div>
				<div v-if="multiPurchaseAlertAction == 'reactivate'" :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="dismissMultiPurchaseAlert(multiPurchaseAlertDetail.ffl_multiple_purchase_id)">Yes, Reactivate</div>
				<div v-if="multiPurchaseAlertAction == 'dismiss'" :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="dismissMultiPurchaseAlert(multiPurchaseAlertDetail.ffl_multiple_purchase_id)">Yes, Dismiss</div>
				<div v-if="multiPurchaseAlertAction == 'new'" :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="startNewForm(multiPurchaseAlertDetail.form_version, multiPurchaseAlertDetail.ffl_multiple_purchase_id, multiPurchaseAlertDetail.contact_id)">Yes, Start {{ multiPurchaseAlertDetail.form_version }}</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{329:'3310 Forms'}" :tours="false"></help-popup>

</div>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue'
import BinaryToggle from '@/components/BinaryToggle.vue'
import { runInThisContext } from 'vm'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'form3310',
    components: {
		'checkbox': Checkbox,
		'binary-toggle': BinaryToggle,
		'help-popup': HelpPopup
	},
	data() {
		return {
			client_id: null,
			logBookForms: [],
			paging: {},
			multiPurchaseAlerts: [],
			multiPurchaseAlertDetail: {},
			multiPurchaseAlertAction: '',
			definition: null,
			showPagination: false,
			filters: {},
			clientFFLNumbers: [],
			loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			loadingPDF: null,
			showModal: false,
			search_contacts: '',
			contactSearchMessage: '',
			contacts: [],
			holidayErrors: [],
            multiplePurchaseContacts: [],
            multiplePurchaseContactsMessage: null,
            formVersion: null,
			showSetBusinessDays: false,
			businessDays: {
				holidays: []
			},
			showSetCLEOInfo: false,
			cleoInfo: {},
			showMultipleSalesSource: false,
			multipleSalesSource: '',
			saving: false,
			modalMessage: '',
			modalSuccess: false,

			contact_data: {},
			form: {},
			firearmsList: []
		}
	},
	created() {
		this.clearFilters()
	},
	computed: {
		hasFilters() {
			return this.filters.search_term || this.filters.start_date || this.filters.end_date
		}
	},
	watch: {
		id (newVal) {
			this.fetchForm()
		}
	},
	methods: {
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading forms...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'get_list_ffl_log_book_forms', data: this.filters }).then((obj) => {
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.client_id = obj.client_id
					this.logBookForms = obj.log_book_forms
					this.definition = obj.definition
					this.paging = obj.paging
					this.showPagination = true
					this.message = ''
					this.clientFFLNumbers = obj.client_ffl_numbers
					if (this.clientFFLNumbers.length > 0 && !this.filters.client_ffl_number_id) {
						this.filters.client_ffl_number_id = this.clientFFLNumbers[0].client_ffl_number_id
					}
				} else {
					this.message = obj.message
				}
				this.loading = false
			}).catch((err) => {
				console.log(err)
				this.loading = false
			})
		},
        getListMultiPurchaseAlerts() {
            this.apiCall({ destination: 'get_list_multiple_purchase_alerts', data: { include_dismissed_alerts: this.filters.include_dismissed_alerts } }).then(obj => {
				if (obj.status == 'success') {
					this.multiPurchaseAlerts = obj.multi_purchase_alerts
					if (this.$route.query.ffl_multiple_purchase_id) {
						// is this id in the list?
						this.multiPurchaseAlertDetail = {}
						for (let i = 0; i < this.multiPurchaseAlerts.length; i++) {
							if (this.multiPurchaseAlerts[i].ffl_multiple_purchase_id == this.$route.query.ffl_multiple_purchase_id) {
								this.setMultiPurchaseAlertAction('new', this.multiPurchaseAlerts[i])
								break
							}
						}
					}

				}
            }).catch(err => {
                console.log(err);
            })
        },
		setMultiPurchaseAlertAction(action, alert) {
			this.multiPurchaseAlertDetail = alert
			this.multiPurchaseAlertAction = action
		},
		dismissMultiPurchaseAlert(multiplePurchaseId) {
			if (this.saving) { return }
			this.saving = true
			this.modalMessage = 'Saving...'
			this.apiCall({ destination: 'dismiss_multiple_purchase_alert', data: { ffl_multiple_purchase_id: multiplePurchaseId, action: this.multiPurchaseAlertAction } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Alert ' + (this.multiPurchaseAlertAction == 'reactivate' ? 'reactivated!' : 'dismissed!')
					this.modalSuccess = true
					setTimeout(() => {
						this.multiPurchaseAlertDetail = {}
						this.multiPurchaseAlertAction = ''
						this.modalMessage = ''
						this.modalSuccess = false
						this.getListMultiPurchaseAlerts()
					}, 1500)
				} else {
					this.modalMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		startNewForm(formVersion, multiPurchaseId, contactId) {
			if (multiPurchaseId) {
				this.$router.push({ path: '/logbooks/3310/new?', query: { contact_id: contactId, ffl_multiple_purchase_id: multiPurchaseId, form_version: formVersion }})
			} else {
				this.formVersion = formVersion
				this.showModal = true
			}
		},
		generatePDFLink(formId) {
			return this.getPDFAPIEndpoint + '?action=form_3310_pdf&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&form_id=' + this.$randomString(6) + formId + this.$randomString(6) + this.client_id + this.$randomString(3)
		},
		clearFilters() {
			let currentFilters = this.$copy(this.filters)
			let currentFFLNumberId = currentFilters.client_ffl_number_id
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: '',
				include_canceled: false,
				form_type: '3310',
				client_ffl_number_id: currentFFLNumberId,
				include_dismissed_alerts: false
			}
			this.getList()
			this.getListMultiPurchaseAlerts()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			if (which == 'include_dismissed_alerts') {
				this.getListMultiPurchaseAlerts()
			} else {
				this.filters.page = 1
				this.getList()
			}
		},
		searchContacts() {
			this.contacts = null
			this.contactSearchMessage = null
			this.apiCall({ destination: 'get_list_logbook_contacts', data: { search_term: this.search_contacts, type: 'both' }}).then(obj => {
				this.client_id = obj.client_id
				if (obj.status == 'error') {
					this.contactSearchMessage = obj.message
				} else if (obj.list.length > 1) {
					this.contacts = obj.list
				} else if (obj.list.length == 1) {
					this.assignContact(obj.list[0])
				} else {
					this.contactSearchMessage = 'nothing found'
				}
			})
		},
		assignContact(contact) {
			this.$router.push('/logbooks/3310/new?form_version=' + this.formVersion + '&contact_id=' + contact.contact_id)
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		fetchForm() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_ffl_log_book_form', data: { ffl_log_book_form_id: this.id }}).then(obj => {
				this.loading = false
				this.client_id = obj.client_id
				if (obj.contact_data) {
					this.contact_data = obj.contact_data
				}
				this.form = obj.log_book_form.form_data

				// convert firearms_list from object to array!
				for (const [key, firearm] of Object.entries(this.form.firearms_list)) {
					this.firearmsList.push(firearm)
				}

				this.form.ffl_log_book_form_id = obj.log_book_form.ffl_log_book_form_id
				this.form.contact_id = obj.log_book_form.contact_id
				this.form.pdf_required = obj.log_book_form.pdf_required
				this.can_submit_to_atf = obj.log_book_form.can_submit_to_atf
				if (!this.form.form_version) {
					this.form.form_version = '3310.4' // default for opening existing forms
				}
			}).catch(err => {
				this.loading = false
				console.log(err)
			})
		},
		startBlankForm() {
			this.$router.push({ path: '/logbooks/3310/new?', query: { form_version: this.formVersion }})
		},
		goToDetail(item) {
			this.$router.push('/logbooks/3310' + (item.form_data.form_version ? '' : '-legacy') + '/' + item.ffl_log_book_form_id)
		},
		addHolidayLine() {
			this.businessDays.holidays.push({ description: '', start: '', end: '' })
		},
		removeHolidayLine(index) {
			this.businessDays.holidays.splice(index, 1)
			if (this.businessDays.holidays.length == 0) {
				this.addHolidayLine()
			}
		},
		setBusinessDays() {
            this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'BUSINESS_DAYS' } }).then(obj => {
				if (obj.BUSINESS_DAYS && obj.BUSINESS_DAYS != '') {
					this.businessDays = JSON.parse(obj.BUSINESS_DAYS)
				}
				if (this.businessDays.holidays.length == 0) {
					this.addHolidayLine()
				}
				this.showSetBusinessDays = true
			}).catch(err => {
                console.log(err);
            })
		},
		saveBusinessDays() {
			if (this.saving) { return }
			if (!this.businessDays.sunday && !this.businessDays.monday && !this.businessDays.tuesday && !this.businessDays.wednesday && !this.businessDays.thursday && !this.businessDays.friday && !this.businessDays.saturday) {
				this.modalMessage = 'Select at least one weekday.'
				setTimeout(() => {
					this.modalMessage = ''
				}, 1500)
				return
			}
			if (!this.validateHolidays()) {
				this.modalMessage = 'Errors, did not save:'
				setTimeout(() => {
					this.modalMessage = ''
					this.holidayErrors = []
				}, 2000)
				return;
			}
			this.saving = true
			this.modalMessage = 'Saving Business Days info...'
            this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'BUSINESS_DAYS', value: JSON.stringify(this.businessDays) } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Business days saved!'
					setTimeout(() => {
						this.showSetBusinessDays = false
						this.modalMessage = ''
					}, 2000)
				} else {
					this.modalMessage = obj.message
				}
			}).catch(err => {
                console.log(err);
            })
		},
		setCLEOInfo() {
            this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'CLEO_AGENCY_INFO' } }).then(obj => {
				if (obj.CLEO_AGENCY_INFO && obj.CLEO_AGENCY_INFO != '') {
					this.cleoInfo = JSON.parse(obj.CLEO_AGENCY_INFO)
				} else {
					this.cleoInfo.use_default_handguns = true
					this.cleoInfo.use_default_long_guns = true
				}
				this.showSetCLEOInfo = true
			}).catch(err => {
                console.log(err);
            })
		},
		saveCLEOInfo() {
			if (this.saving) { return }
			this.saving = true
			this.modalMessage = 'Saving CLEO info...'
            this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'CLEO_AGENCY_INFO', value: JSON.stringify(this.cleoInfo) } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'CLEO info saved!'
					setTimeout(() => {
						this.showSetCLEOInfo = false
						this.modalMessage = ''
					}, 2000)
				} else {
					this.modalMessage = obj.message
				}
			}).catch(err => {
                console.log(err);
            })
		},
		setMultipleSalesSource() {
            this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'MULTIPLE_FIREARMS_SALES_SOURCE' } }).then(obj => {
				this.multipleSalesSource = obj.MULTIPLE_FIREARMS_SALES_SOURCE
				this.showMultipleSalesSource = true
			}).catch(err => {
                console.log(err);
            })
		},
		saveMultipleSalesSource() {
			if (this.saving) { return }
			this.saving = true
			this.modalMessage = 'Saving multiple sales source...'
            this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'MULTIPLE_FIREARMS_SALES_SOURCE', value: this.multipleSalesSource } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Multiple firearms sales source saved!'
					setTimeout(() => {
						this.showMultipleSalesSource = false
						this.modalMessage = ''
					}, 2000)
				} else {
					this.modalMessage = obj.message
				}
			}).catch(err => {
                console.log(err);
            })
		},
		validateHolidays() {
			// 'empty' default holiday 
			if (this.businessDays.holidays.length === 1 &&
				this.businessDays.holidays[0].start === '' &&
				this.businessDays.holidays[0].end === '' &&
				this.businessDays.holidays[0].description === '') {
					return true
			}

			this.holidayErrors = []

			// check start and end dates
			this.businessDays.holidays.forEach((holiday, index) => {
				const description = (holiday.description || `Holiday ${index + 1}`) + ' - '
				if (!holiday.start) {
					this.holidayErrors.push(description + 'invalid start date')
				}
	
				if (!holiday.end) {
					this.holidayErrors.push(description + 'invalid end date')
				}

				if (holiday.start && holiday.end) {
					const start = new Date(holiday.start)
					const end = new Date(holiday.end)
		
					if (start > end) {
						this.holidayErrors.push(description + 'start date greater than end')
					}
				}
			})
			return this.holidayErrors.length === 0
		}
	}
}
</script>

<style lang="scss" scoped>
.inner { max-width: fit-content !important; }
.list tr:hover:first-child .link {
    display: block;
}
.search-list {
    margin-bottom: 1em;
	border-bottom: 1px solid;
	padding-bottom: 1em;
    span {
        display: inline-block;
        margin-right: 5px;
		float: right;
    }
	span:first-of-type {
		font-weight: bold;
		float: none;
	}
}
</style>
